const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export const formatMoney = (num: number) => {
  return formatter.format(num)
}
